var _defs, _circle, _circle2, _circle3, _circle4, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBody1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.41 622.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin-dark {\n        fill: #b7876c;\n      }\n      .skin {\n        fill: #d6a07c;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "skin-dark",
    cx: 340.94,
    cy: 546.09,
    r: 76.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 337.17,
    cy: 277.23,
    r: 277.23
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 61.7,
    cy: 319.98,
    r: 61.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "skin",
    cx: 604.71,
    cy: 319.98,
    r: 61.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "skin-dark",
    cx: 337.06,
    cy: 356.03,
    rx: 42.34,
    ry: 30.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody1);
export default __webpack_public_path__ + "static/media/body1.bb0ce7eb.svg";
export { ForwardRef as ReactComponent };